export class FileAccumulator {
  private list: File[] = [];

  add(f: File): void {
    this.list.push(f);
  }

  dispose(): void {
    this.list.length = 0;
  }

  get empty(): boolean {
    return !this.list.length;
  }

  get files(): File[] {
    const result = this.list;
    this.list = [];
    return result;
  }
}